import TrackingUtils from "@tracking/utils/TrackingUtils";
import loadable from "@loadable/component";
import { Redirect } from "react-router-dom";
import LinearProgress from "@material-ui/core/LinearProgress";
import NotFound from "app/main/_404/_404";
import React from "react";

const createSafeLoadable = (importFn: () => Promise<any>) => {
  return loadable(
    () =>
      importFn().catch(() => {
        return { default: NotFound };
      }),
    {
      fallback: (
        <div className="w-full flex flex-col top-1/3 absolute">
          <LinearProgress className="w-96 mx-auto" />
        </div>
      ),
    }
  );
};

export const defaultRoutesObj = [
  {
    settings: {
      layout: {
        config: {},
      },
    },
    routes: [
      {
        path: "/faq",
        component: loadable(() => import("app/main/faq/Faq"), {
          fallback: (
            <div className="w-full flex flex-col top-1/3 absolute">
              <LinearProgress className="w-96 mx-auto" />
            </div>
          ),
        }),
      },
    ],
  },
  {
    settings: {
      layout: {
        config: {},
      },
    },
    routes: [
      {
        path: "/home",
        component: loadable(() => import("app/main/home/Home"), {
          fallback: (
            <div className="w-full flex flex-col top-1/3 absolute">
              <LinearProgress className="w-96 mx-auto" />
            </div>
          ),
        }),
      },
    ],
  },
  {
    settings: {
      layout: {
        config: {},
      },
    },
    routes: [
      {
        path: "/lista-pedidos/:params?",
        component: loadable(
          () => import("app/main/listaPedidos/ListaPedidos"),
          {
            fallback: (
              <div className="w-full flex flex-col top-1/3 absolute">
                <LinearProgress className="w-96 mx-auto" />
              </div>
            ),
          }
        ),
      },
    ],
  },
  {
    settings: {
      layout: {
        config: {},
      },
    },
    routes: [
      {
        path: "/lista-pedidos-lml/:params?",
        component: loadable(
          () => import("app/main/listaPedidosLML/ListaPedidosLML"),
          {
            fallback: (
              <div className="w-full flex flex-col top-1/3 absolute">
                <LinearProgress className="w-96 mx-auto" />
              </div>
            ),
          }
        ),
      },
    ],
  },
  {
    settings: {
      layout: {
        config: {},
      },
    },
    routes: [
      {
        path: "/lista-pedidos-minihub/:params?",
        component: loadable(
          () => import("app/main/listaPedidosMiniHub/ListaPedidosMiniHub"),
          {
            fallback: (
              <div className="w-full flex flex-col top-1/3 absolute">
                <LinearProgress className="w-96 mx-auto" />
              </div>
            ),
          }
        ),
      },
    ],
  },
  {
    settings: {
      layout: {
        config: {},
      },
    },
    routes: [
      {
        path: "/lista-pedidos-fracionados/:params?",
        component: loadable(
          () =>
            import("app/main/listaPedidosFracionados/ListaPedidosFracionados"),
          {
            fallback: (
              <div className="w-full flex flex-col top-1/3 absolute">
                <LinearProgress className="w-96 mx-auto" />
              </div>
            ),
          }
        ),
      },
    ],
  },
];

const getOrdemValue = (item: { ordem?: number | string }) => {
  const ordem = Number(item?.ordem);
  return Number.isFinite(ordem) ? ordem : Number.MAX_SAFE_INTEGER;
};

const compareMenuItemsByOrdem = (a: any, b: any) => {
  const ordemDiff = getOrdemValue(a) - getOrdemValue(b);
  if (ordemDiff !== 0) return ordemDiff;
  return (a?.descricao ?? "").localeCompare(b?.descricao ?? "");
};

export const sortMenuItemsByOrdem = (items: any[] = []) => {
  return [...items]
    .sort(compareMenuItemsByOrdem)
    .map((item) => {
      if (!item?.subMenus?.length) return item;
      return {
        ...item,
        subMenus: sortMenuItemsByOrdem(item.subMenus),
      };
    });
};

export const formatArrayAccessUser = (arr) => {
  let result: any = [...defaultRoutesObj];
  arr.forEach((item: { componente: string; rota: string; subMenus: any }) => {
    if (item.componente && !item.subMenus) {
      result.push({
        settings: {
          layout: {
            config: {},
          },
        },
        routes: [
          {
            path: item.rota,
            component: createSafeLoadable(
              () => import(`app/main/${item.componente}`)
            ),
          },
        ],
      });
    } else if (item.subMenus) {
      item.subMenus.forEach((subMenu: { componente: string; rota: string }) => {
        result.push({
          settings: {
            layout: {
              config: {},
            },
          },
          routes: [
            {
              path: subMenu.rota,
              component: createSafeLoadable(
                () => import(`app/main/${subMenu.componente}`)
              ),
            },
          ],
        });
      });
    }
  });
  return result;
};

export const generateRoutes = (routes) => {
  return [
    ...TrackingUtils.generateRoutesFromConfigs(routes),
    {
      path: "/",
      component: () => <Redirect to="/home" />,
    },
  ];
};

export const verifyAllowedUserAccess = (routes = []) => {
  const allowedRoutes = {};
  routes.forEach((route) => {
    if (route.componente && !route.subMenus) {
      allowedRoutes[route.descricao.toLowerCase()] = {
        isAccessible: true,
        path: route.rota,
      };
    } else if (route.subMenus) {
      route.subMenus.forEach((subMenu) => {
        allowedRoutes[route.descricao.toLowerCase()] = {
          isAccessible: true,
          path: subMenu.rota,
        };
      });
    }
  });
  return allowedRoutes;
};
